"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var logger = __importStar(require("../logger/logger"));
var base64_helpers_1 = require("../helpers/base64-helpers");
var base64_1 = require("../helpers/base64");
var domains_1 = require("./domains");
var location_tools_1 = require("../helpers/location-tools");
var randomizers_1 = require("../helpers/randomizers");
var displayName = 'Crux.unmess';
var ES = '';
var SL = '/';
/**
 * @description
 * Pobiera sxorowane dane i zwraca rozkodowane dane (ścieżka, identyfikator)
 * @param sxored
 * @return {{identifier: (*|string), path: (*|string)}}
 */
var getSxoredData = function (sxored) {
    if (sxored.indexOf('/aabv3/') !== 0) {
        throw new Error('AABv2 is no longer supported');
    }
    var objectData = JSON.parse(sxored.replace('/aabv3/', ES));
    var identifier = objectData.t || ES;
    var path = objectData.u || ES;
    logger.debug(displayName, 'getSxoredData', 'sxored', sxored, 'identifier', identifier, 'path', path);
    return {
        identifier: identifier,
        path: path,
    };
};
/**
 * @description Rozkodowuje zakodowany adres
 * @param url
 * @return {string}
 */
var unmess = function (url) {
    var _a;
    logger.debug(displayName, url);
    // eslint-disable-next-line @typescript-eslint/prefer-string-starts-ends-with
    if (/^data:/.test(url)) {
        return url;
    }
    // rozbijam adres na location
    var _b = (0, location_tools_1.parsePath)(url), error = _b.error, _c = _b.hostname, hostname = _c === void 0 ? '' : _c, _d = _b.pathname, pathname = _d === void 0 ? '' : _d, _e = _b.search, search = _e === void 0 ? '' : _e;
    if (error) {
        return url;
    }
    // pobieram pathname i obcinam slashe
    var trimmedPathname = pathname.replace(/^\/|\/$/g, ES);
    // dziele pathname slashami na tablice
    var pathParts = trimmedPathname.split(SL);
    // wyciągam pierwszy element, który jest zakodowana częścią adresu
    var encoded = pathParts.shift();
    var output = url;
    var found = false;
    var identifier = ES;
    var path = ES;
    // jeżeli za krotki ciąg znaków
    if (encoded.length < 30) {
        return url;
    }
    try {
        // zamieniam _ na / i - na +, bo kodowanie jest base64 urlSafe
        encoded = encoded.replace(/_/g, SL);
        encoded = encoded.replace(/-/g, '+');
        // pierwsze 8 znaków to checksum
        var checksum = encoded.slice(0, 8);
        // pozostałe to część adresu do odkodowania
        var toDecode = encoded.slice(8);
        // dekoduje base64
        var decoded = (0, base64_1.atob)((0, base64_helpers_1.addEqualSigns)(toDecode));
        // dekoduje XOR
        var sxored = (0, randomizers_1.sxor)(decoded, checksum);
        // pierwszy element to id domeny
        (_a = getSxoredData(sxored), identifier = _a.identifier, path = _a.path);
    }
    catch (err) {
        return url;
    }
    var finalHostname = ES;
    // szukam domeny wg id
    found = Object
        .entries(domains_1.domainMap)
        .find(function (_a) {
        var hn = _a[0], hostIdentifier = _a[1];
        if (hostIdentifier === identifier) {
            finalHostname = hn;
            return true;
        }
        return false;
    });
    if (!found) {
        var cephDomain = (0, domains_1.getCephDomain)(identifier);
        if (cephDomain) {
            found = true;
            finalHostname = cephDomain;
        }
    }
    if (!found) {
        finalHostname = hostname;
    }
    // składam docelowy adres
    try {
        var escapeAndDecodedPath = decodeURIComponent(escape(path));
        output = "https://".concat(finalHostname).concat(escapeAndDecodedPath).concat(pathParts.length ? pathParts.join('/') : ES).concat(search);
        output = output.replace(/[?&]?_=_+$/, ES);
    }
    catch (error) {
        output = url;
    }
    return output;
};
exports.default = unmess;
